import Page from '../../layout/Page'
import PatientDetailsPageContent from './PatientDetailsPageContent'

const PatientDetailsPage = () => (
  <Page content={<PatientDetailsPageContent />} menu={undefined} />
)

export default PatientDetailsPage
